export function indicatorLight(ctx, node) {
    const {x: i, y: n, width: r, height: o} = node.rect;
    ctx.save();
    const s = isFinite(ctx.globalAlpha) ? ctx.globalAlpha : 1;
    if(node.data){
        node.value=node.data[0].value;
        if(node.value==undefined){
            node.value=0;
        }
    }
    if (0 === node.value) {
        const e = 70 / 513 * o
          , a = 93 / 513 * r
          , c = 219 / 512 * r
          , l = 135 / 513 * o
          , h = 250 / 513 * o;
        ctx.beginPath(),
        ctx.rect(i, n + o - e, r, e),
        ctx.closePath(),
        ctx.globalAlpha = .45 * s,
        ctx.stroke(),
        ctx.globalAlpha = .5 * s,
        ctx.fill(),
        ctx.beginPath(),
        ctx.moveTo(i + r / 2 - c, n + o - e),
        ctx.lineTo(i + r / 2 - c, n + l),
        ctx.arc(i + r / 2, n + l, c, Math.PI, 2 * Math.PI),
        ctx.lineTo(i + r / 2 + c, n + o - e),
        ctx.closePath(),
        ctx.globalAlpha = .45 * s,
        ctx.stroke(),
        ctx.globalAlpha = .25 * s,
        ctx.fill(),
        ctx.beginPath(),
        ctx.moveTo(i + r / 2 - a, n + o - e),
        ctx.lineTo(i + r / 2 - a, n + h),
        ctx.arc(i + r / 2, n + h, a, Math.PI, 2 * Math.PI),
        ctx.lineTo(i + r / 2 + a, n + o - e),
        ctx.closePath(),
        ctx.globalAlpha = .45 * s,
        ctx.stroke(),
        ctx.globalAlpha = .5 * s,
        ctx.fill()
    } else if (1 === node.value) {
        ctx.beginPath(),
        ctx.rect(i, n, r, o),
        ctx.closePath(),
        ctx.globalAlpha = .45 * s,
        ctx.stroke(),
        ctx.globalAlpha = .25 * s,
        ctx.fill();
        let e = r / 10;
        r > o && (e = o / 10),
        ctx.beginPath(),
        ctx.rect(i + e, n + e, r - 2 * e, o - 2 * e),
        ctx.closePath(),
        ctx.globalAlpha = .45 * s,
        ctx.stroke(),
        ctx.globalAlpha = .5 * s,
        ctx.fill()
    } else if (2 === node.value) {
        ctx.beginPath();
        let e = r / 2;
        r > o && (e = o / 2),
        ctx.arc(i + r / 2, n + o / 2, e - e / 5, 0, 2 * Math.PI),
        ctx.closePath(),
        ctx.globalAlpha = .45 * s,
        ctx.stroke(),
        ctx.globalAlpha = .25 * s,
        ctx.fill(),
        ctx.beginPath(),
        ctx.arc(i + r / 2, n + o / 2, e, 0, 2 * Math.PI),
        ctx.closePath(),
        ctx.globalAlpha = .45 * s,
        ctx.stroke(),
        ctx.globalAlpha = .5 * s,
        ctx.fill()
    }
    return ctx.restore(),
    !1
}

